import { isDefined, numberOrZero } from "@/utils/utils";
import { Button, Popover } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { formatLocaleNumber } from "../../../../../../common/utils/formatUtils";
import { DashboardGoalType } from "../../../../enums";
import { DashboardGoal } from "../../../../types";
import { getPercentage } from "../../../../utils";
import { GoalCard } from "../cards/GoalCard";
import { AddGoalModal } from "../modals/AddGoalModal";
import { isCreatedGoal } from "../utils";

type Props = {
  goal?: DashboardGoal;
  year: number;
  agentId: string;
};

export const BrokerAgentsWrapper = ({ goal, year, agentId }: Props) => {
  const { t } = useTranslation();

  const [isOpenSetGoalModal, setIsOpenSetGoalModal] = useState(false);

  const hasTarget = isDefined(goal?.targetValue);
  const actualValue = numberOrZero(goal?.actualValue);
  const targetValue = numberOrZero(goal?.targetValue);

  const currentPercentage = isCreatedGoal(goal) ? getPercentage(actualValue, targetValue) : 0;

  return (
    <>
      <GoalCard
        agentId={agentId}
        year={year}
        goal={goal}
        percentage={currentPercentage}
        tooltipTitle={
          hasTarget ? (
            <p>
              {actualValue} {t("dashboard.goals.helpers.brokers")} {t("dashboard.goals.helpers.from")} {targetValue}
            </p>
          ) : undefined
        }
        isGaugeStyle
        label={
          hasTarget ? (
            <Popover content={t("dashboard.goals.helpers.agentsGoalHint")}>
              {t("dashboard.enums.dashboardGoalType.BROKER_AGENTS")}
            </Popover>
          ) : (
            <Button onClick={() => setIsOpenSetGoalModal(true)}>{t("dashboard.goals.actions.setTarget")}</Button>
          )
        }
        hasTarget={hasTarget}
        targetLabel={
          hasTarget ? undefined : (
            <div style={{ color: "white" }}>
              <div>{formatLocaleNumber(actualValue)}</div>
              <span style={{ fontSize: 16 }}>{t("dashboard.enums.dashboardGoalType.BROKER_AGENTS")}</span>
            </div>
          )
        }
      />

      <AddGoalModal
        isOpen={isOpenSetGoalModal}
        onCancel={() => setIsOpenSetGoalModal(false)}
        goalType={DashboardGoalType.BROKER_AGENTS}
        year={year}
        agentId={agentId}
      />
    </>
  );
};
